import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { completePlanDeveloppementStepRequest, createDemandeFormationFromPlanRequest, fetchPlanDeveloppementStepRequest, generatePlanDeveloppementRecommendationsRequest } from "../../../../redux/actions/performanceActions";
import { asArray, StepState } from "../../Collaborateur/performanceUi";
import "../../Collaborateur/steps/PlanDeveloppementStep.css";

const staticPlanCards = [
    {
        title: "Leadership et Management",
        text: "Developper les pratiques de leadership, d'accompagnement et de pilotage d'equipe.",
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978",
        badge: "Formation",
    },
    {
        title: "Gestion de projet",
        text: "Structurer les priorites, les livrables et le suivi des actions avec une methode claire.",
        image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40",
        badge: "Formation",
    },
    {
        title: "Communication efficace",
        text: "Renforcer la qualite des echanges, la clarte des messages et la collaboration.",
        image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d",
        badge: "Formation",
    },
];

export default function PlanDeveloppementManagerStep({ progressId }) {
    const dispatch = useDispatch();
    const slice = useSelector((state) => state.performance.planDeveloppement);
    const data = slice.stepByProgressId[String(progressId)];
    const loading = slice.loadingByProgressId[String(progressId)];
    const error = slice.errorByProgressId[String(progressId)];
    const recommendations = asArray(data?.recommendations);
    const items = asArray(data?.items);
    const hasFormationCampaign = data?.formationCampaignAssociated !== false;

    useEffect(() => {
        dispatch(fetchPlanDeveloppementStepRequest(progressId));
    }, [dispatch, progressId]);

    return (
        <StepState loading={loading} error={error} empty={!data}>
            {!hasFormationCampaign ? (
                <div className="plan-container">
                    <h3 className="plan-section">Plan de developpement</h3>
                    <div className="plan-grid">
                        {staticPlanCards.map((card) => (
                            <div className="plan-card" key={card.title}>
                                <div className="plan-card__image">
                                    <img src={card.image} alt="" />
                                    <span className="plan-badge">{card.badge}</span>
                                </div>
                                <div className="plan-card__content">
                                    <h4>{card.title}</h4>
                                    <p>{card.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <>
                    {data?.blockedReason && <div className="perf-state perf-state--warning">{data.blockedReason}</div>}
                    <div className="perf-actions perf-actions--top">
                        <button className="perf-btn" type="button" onClick={() => dispatch(generatePlanDeveloppementRecommendationsRequest(progressId))}>Regenerer recommandations</button>
                        <button className="perf-btn perf-btn--primary" type="button" onClick={() => dispatch(completePlanDeveloppementStepRequest(progressId))}>Terminer l'etape</button>
                    </div>
                    <h3 className="perf-section-title">Recommandations backend</h3>
                    {recommendations.length === 0 && <div className="perf-state">Aucune recommandation.</div>}
                    <div className="perf-stack">
                        {recommendations.map((recommendation, index) => (
                            <article className="perf-item" key={recommendation.competenceNom || recommendation.skillNom || index}>
                                <div className="perf-item__head">
                                    <h3>{recommendation.competenceNom || recommendation.skillNom || "Recommendation"}</h3>
                                    <span className="perf-badge perf-badge--red">Gap {recommendation.gap ?? "-"}</span>
                                </div>
                                <p>{recommendation.reason || "Recommandation proposee par le backend."}</p>
                            </article>
                        ))}
                    </div>
                    <h3 className="perf-section-title">Plan de developpement</h3>
                    {items.length === 0 && <div className="perf-state">Aucun element dans le plan.</div>}
                    <div className="perf-stack">
                        {items.map((item) => (
                            <article className="perf-item" key={item.id}>
                                <div className="perf-item__head">
                                    <h3>{item.formationNom || item.competenceNom || item.skillNom || "Action de developpement"}</h3>
                                    <span className="perf-badge perf-badge--green">{item.status || "PLAN"}</span>
                                </div>
                                <p>{item.recommendationReason || item.commentaire || "Action ajoutee au plan."}</p>
                                <button className="perf-btn" type="button" onClick={() => dispatch(createDemandeFormationFromPlanRequest({ planDeveloppementItemId: item.id }))}>Créer demande formation</button>
                            </article>
                        ))}
                    </div>
                </>
            )}
        </StepState>
    );
}
